export default __webpack_public_path__ + "static/media/svg7.a2d4a575.svg";